import { render, staticRenderFns } from "./ActivationsEditTable.vue?vue&type=template&id=f39e9d4a&scoped=true"
import script from "./ActivationsEditTable.vue?vue&type=script&lang=ts"
export * from "./ActivationsEditTable.vue?vue&type=script&lang=ts"
import style0 from "./ActivationsEditTable.vue?vue&type=style&index=0&id=f39e9d4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39e9d4a",
  null
  
)

export default component.exports